import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'

Vue.use(Router)

export default new Router({
  routes: [{
      path: '/',
      name: 'home',
      component: () => import('./views/Login.vue')
    },
    {
      path: '/admin',
      name: 'admin',
      component: () => import('./views/Home.vue')
    },
    {
      path: '/scanlogin',
      name: 'scanlogin',
      component: () => import('./views/ScanLogin.vue')
    },
    {
      path: '/scangoods',
      name: 'scangoods',
      component: () => import('./views/ScanGoods.vue')
    },
    {
      path: '/scantime',
      name: 'scantime',
      component: () => import('./views/ScanTime.vue')
    },
    {
      path: '/scan3hr',
      name: 'scan3hr',
      component: () => import('./views/Scan3hr.vue')
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('./views/Login.vue')
    },
    {
      path: '/qr',
      name: 'qr',
      component: () => import('./views/QR.vue')
    }
  ]
})